// engine
import { ArController, delay } from '@aceroll/core';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

// platform
import { platform } from '../../platform';
import dataActionType from '../../platform/constants/data-action-type';

// services
import { autoplayService } from '../../services/autoplay-service';
import { respinService } from '../../services/respin-service';
import { winAnimationService } from '../../services/win-animation-service';

export class EvReveal extends ArController {
	async onStart() {
		const serverEvent = responseService.getEvent();
		platform.setResultDisplay();

		await Promise.all([
			winAnimationService.playEvent(serverEvent),
			this.spinDelay()
		]);

		if (this.isWinCycle(serverEvent)) {
			winAnimationService.playWinCycle(serverEvent);
		}


		responseService.completeEvent();
		this.stop();
	}

	async spinDelay() {
		if (autoplayService.started || respinService.started) {
			await delay(250);
		}
	}
	isWinCycle(serverEvent) {
		const { data } = serverEvent;
		const actions = data.actions;

		if (autoplayService.started) {
			return false;
		}

		// Multiplier animation should be played before the total win animation because the multipliers are included to total win
		const list = actions.filter((action) => {
			return action.type === dataActionType.ADD ||
				action.type === dataActionType.MULTIPLY ||
				action.type === dataActionType.EPIC_ADD ||
				action.type === dataActionType.EPIC_MULTIPLIY ||
				action.type === dataActionType.BONUS
		});
		return list.length === 0;
	}
}
